module.exports = __webpack_public_path__ + "static/media/lz2.5e1afaf4.jpg";